export default "__VITE_ASSET__DORgpUTb__"